export default Api;

import * as angular from 'angular';

/** @ngInject */
function Api($http, $state, API_URL, QueryString, $window, $mdDialog) {
  var vm = this;

  var config = {timeout: 6000};

  var msgErroDefault = 'Verifique sua conexão com a internet!';

  let alert = $mdDialog.alert()
    .parent(angular.element($window.document.body))
    .ariaLabel('Alerta de erro')
    .ok('Fechar');

  vm.buscarDados = buscarDados;
  vm.enviarDados = enviarDados;

  function buscarDados(classe, metodo, parametros) {
    return $http
      .get(API_URL + '?' + QueryString.stringify({
        c: classe,
        a: metodo,
        p: parametros
      }), config)
      .then(res => res.data)
      .catch(showError);
  }

  function enviarDados(classe, metodo, parametros) {
    return $http
      .post(API_URL, QueryString.stringify({
        c: classe,
        a: metodo,
        p: parametros
      }), config)
      .then(res => res.data)
      .catch(showError);
  }

  function showError(res) {

    $mdDialog.hide();

    if ([0, 400, 404].indexOf(res.status) !== -1) {
      alert.title('Ocorreu um erro!').content(res.data && res.data.erro || msgErroDefault);
      $mdDialog.show(alert);
    } else if ([401, 403].indexOf(res.status) !== -1) {
      alert.title('Aviso').content('Para acessar este conteúdo você precisa realizar o login!');
      $mdDialog.show(alert);
      $state.go('consulta.usuario.login');
    }

    throw res;
  }
}



/** WEBPACK FOOTER **
 ** ./common/services/api.service.ts
 **/